export const DocTypeMock = [
  {
    value: '1',
    text:
      'нотариально удостоверенная сделка, устанавливающая денежные обязательства или обязательства по передаче имущества',
  },
  {
    value: '2',
    text:
      'кредитный договор, кредитором по которому выступает не являющаяся микрофинансовой организация\n' +
      ' (в договоре или дополнительных соглашениях к нему указаны условия о возможности взыскания задолженности\n' +
      ' по исполнительной надписи нотариуса)',
  },
  {
    value: '3',
    text:
      'договор займа, кредитором по которому выступает единый институт развития в жилищной сфере\n' +
      '(в договоре или дополнительных соглашениях к нему указаны условия о возможности взыскания задолженности\n' +
      'по исполнительной надписи нотариуса)',
  },
  {
    value: '4',
    text:
      'кредитный договор, кредитором по которому на основании уступки прав (требований) выступает единый институт\n' +
      ' развития в жилищной сфере (в договоре или дополнительных соглашениях к нему указаны условия о возможности взыскания\n' +
      ' задолженности по исполнительной надписи нотариуса)',
  },
  {
    value: '5',
    text:
      'договор поручительства, предусматривающий солидарную ответственность поручителя по кредитному договору\n' +
      '(в договоре поручительства указаны условия о возможности взыскания задолженности по исполнительной надписи нотариуса)',
  },
  {
    value: '6',
    text:
      'договор об оказании услуг связи в случае неисполнения обязательств по оплате услуг в сроки, установленные в договоре\n' +
      'об оказании услуг связи (в договоре указаны условия о возможности взыскания задолженности по исполнительной надписи нотариуса)',
  },
  { value: '7', text: 'договор займа (залоговый билет)' },
  { value: '8', text: 'договор хранения' },
  { value: '9', text: 'договор проката' },
];

/*/!*export const REGION_lIST = [
    '1 - Республика Адыгея (Адыгея)',
    '2 - Республика Башкортостан',
    '3 - Республика Бурятия',
    '4 - Республика Алтай',
    '5 - Республика Дагестан',
    '6 - Республика Ингушетия',
    '7 - Кабардино-Балкарская Республика',
    '8 - Республика Калмыкия',
    '9 - Карачаево-Черкесская Республика',
    '10 - Республика Карелия',
    '11 - Республика Коми',
    '12 - Республика Марий Эл',
    '13 - Республика Мордовия',
    '14 - Республика Саха (Якутия)',
    '15 - Республика Северная Осетия - Алания',
    '16 - Республика Татарстан (Татарстан)',
    '17 - Республика Тыва',
    '18 - Удмуртская Республика',
    '19 - Республика Хакасия',
    '20 - Чеченская Республика',
    '21 - Чувашская Республика - Чувашия',
    '22 - Алтайский край',
    '23 - Краснодарский край',
    '24 - Красноярский край',
    '25 - Приморский край',
    '26 - Ставропольский край',
    '27 - Хабаровский край',
    '28 - Амурская область',
    '29 - Архангельская область',
    '30 - Астраханская область',
    '31 - Белгородская область',
    '32 - Брянская область',
    '33 - Владимирская область',
    '34 - Волгоградская область',
    '35 - Вологодская область',
    '36 - Воронежская область',
    '37 - Ивановская область',
    '38 - Иркутская область',
    '39 - Калининградская область',
    '40 - Калужская область',
    '41 - Камчатский край',
    '42 - Кемеровская область',
    '43 - Кировская область',
    '44 - Костромская область',
    '45 - Курганская область',
    '46 - Курская область',
    '47 - Ленинградская область',
    '48 - Липецкая область',
    '49 - Магаданская область',
    '50 - Московская область',
    '51 - Мурманская область',
    '52 - Нижегородская область',
    '53 - Новгородская область',
    '54 - Новосибирская область',
    '55 - Омская область',
    '56 - Оренбургская область',
    '57 - Орловская область',
    '58 - Пензенская область',
    '59 - Пермский край',
    '60 - Псковская область',
    '61 - Ростовская область',
    '62 - Рязанская область',
    '63 - Самарская область',
    '64 - Саратовская область',
    '65 - Сахалинская область',
    '66 - Свердловская область',
    '67 - Смоленская область',
    '68 - Тамбовская область',
    '69 - Тверская область',
    '70 - Томская область',
    '71 - Тульская область',
    '72 - Тюменская область',
    '73 - Ульяновская область',
    '74 - Челябинская область',
    '75 - Забайкальский край',
    '76 - Ярославская область',
    '77 - г. Москва',
    '78 - Санкт-Петербург',
    '79 - Еврейская автономная область',
    '83 - Ненецкий автономный округ',
    '86 - Ханты-Мансийский автономный округ - Югра',
    '87 - Чукотский автономный округ',
    '89 - Ямало-Ненецкий автономный округ',
    '91 - Республика Крым',
    '92 - Севастополь',
    '99 - Иные территории, включая город и космодром Байконур',
]*/

export const REGION_LIST = [
  {
    regionCode: '22',
    regionName: 'Алтайский край',
  },
  {
    regionCode: '28',
    regionName: 'Амурская область',
  },
  {
    regionCode: '29',
    regionName: 'Архангельская область',
  },
  {
    regionCode: '30',
    regionName: 'Астраханская область',
  },
  {
    regionCode: '31',
    regionName: 'Белгородская область',
  },
  {
    regionCode: '32',
    regionName: 'Брянская область',
  },
  {
    regionCode: '33',
    regionName: 'Владимирская область',
  },
  {
    regionCode: '34',
    regionName: 'Волгоградская область',
  },
  {
    regionCode: '35',
    regionName: 'Вологодская область',
  },
  {
    regionCode: '36',
    regionName: 'Воронежская область',
  },
  {
    regionCode: '79',
    regionName: 'Еврейская А.О.',
  },
  {
    regionCode: '75',
    regionName: 'Забайкальский край',
  },
  {
    regionCode: '37',
    regionName: 'Ивановская область',
  },
  {
    regionCode: '38',
    regionName: 'Иркутская область',
  },
  {
    regionCode: '7',
    regionName: 'Кабардино-Балкарская Республика',
  },
  {
    regionCode: '39',
    regionName: 'Калининградская область',
  },
  {
    regionCode: '40',
    regionName: 'Калужская область',
  },
  {
    regionCode: '41',
    regionName: 'Камчатский край',
  },
  {
    regionCode: '9',
    regionName: 'Карачаево-Черкесская Республика',
  },
  {
    regionCode: '42',
    regionName: 'Кемеровская область',
  },
  {
    regionCode: '43',
    regionName: 'Кировская область',
  },
  {
    regionCode: '44',
    regionName: 'Костромская область',
  },
  {
    regionCode: '23',
    regionName: 'Краснодарский край',
  },
  {
    regionCode: '24',
    regionName: 'Красноярский край',
  },
  {
    regionCode: '45',
    regionName: 'Курганская область',
  },
  {
    regionCode: '46',
    regionName: 'Курская область',
  },
  {
    regionCode: '47',
    regionName: 'Ленинградская область',
  },
  {
    regionCode: '48',
    regionName: 'Липецкая область',
  },
  {
    regionCode: '49',
    regionName: 'Магаданская область',
  },
  {
    regionCode: '77',
    regionName: 'Москва',
  },
  {
    regionCode: '50',
    regionName: 'Московская область',
  },
  {
    regionCode: '51',
    regionName: 'Мурманская область',
  },
  {
    regionCode: '83',
    regionName: 'Ненецкий А.О.',
  },
  {
    regionCode: '52',
    regionName: 'Нижегородская область',
  },
  {
    regionCode: '53',
    regionName: 'Новгородская область',
  },
  {
    regionCode: '54',
    regionName: 'Новосибирская область',
  },
  {
    regionCode: '55',
    regionName: 'Омская область',
  },
  {
    regionCode: '56',
    regionName: 'Оренбургская область',
  },
  {
    regionCode: '57',
    regionName: 'Орловская область',
  },
  {
    regionCode: '58',
    regionName: 'Пензенская область',
  },
  {
    regionCode: '59',
    regionName: 'Пермский край',
  },
  {
    regionCode: '25',
    regionName: 'Приморский край',
  },
  {
    regionCode: '60',
    regionName: 'Псковская область',
  },
  {
    regionCode: '1',
    regionName: 'Республика Адыгея',
  },
  {
    regionCode: '4',
    regionName: 'Республика Алтай',
  },
  {
    regionCode: '2',
    regionName: 'Республика Башкортостан',
  },
  {
    regionCode: '3',
    regionName: 'Республика Бурятия',
  },
  {
    regionCode: '5',
    regionName: 'Республика Дагестан',
  },
  {
    regionCode: '6',
    regionName: 'Республика Ингушетия',
  },
  {
    regionCode: '8',
    regionName: 'Республика Калмыкия',
  },
  {
    regionCode: '10',
    regionName: 'Республика Карелия',
  },
  {
    regionCode: '11',
    regionName: 'Республика Коми',
  },
  {
    regionCode: '91',
    regionName: 'Республика Крым',
  },
  {
    regionCode: '12',
    regionName: 'Республика Марий Эл',
  },
  {
    regionCode: '13',
    regionName: 'Республика Мордовия',
  },
  {
    regionCode: '14',
    regionName: 'Республика Саха (Якутия)',
  },
  {
    regionCode: '15',
    regionName: 'Республика Северная Осетия - Алания',
  },
  {
    regionCode: '16',
    regionName: 'Республика Татарстан',
  },
  {
    regionCode: '17',
    regionName: 'Республика Тыва',
  },
  {
    regionCode: '19',
    regionName: 'Республика Хакасия',
  },
  {
    regionCode: '61',
    regionName: 'Ростовская область',
  },
  {
    regionCode: '62',
    regionName: 'Рязанская область',
  },
  {
    regionCode: '63',
    regionName: 'Самарская область',
  },
  {
    regionCode: '78',
    regionName: 'Санкт-Петербург',
  },
  {
    regionCode: '64',
    regionName: 'Саратовская область',
  },
  {
    regionCode: '65',
    regionName: 'Сахалинская область',
  },
  {
    regionCode: '66',
    regionName: 'Свердловская область',
  },
  {
    regionCode: '92',
    regionName: 'Севастополь',
  },
  {
    regionCode: '67',
    regionName: 'Смоленская область',
  },
  {
    regionCode: '26',
    regionName: 'Ставропольский край',
  },
  {
    regionCode: '84',
    regionName: 'Таймырский (Долгано-Ненецкий) А.О.',
  },
  {
    regionCode: '68',
    regionName: 'Тамбовская область',
  },
  {
    regionCode: '69',
    regionName: 'Тверская область',
  },
  {
    regionCode: '70',
    regionName: 'Томская область',
  },
  {
    regionCode: '71',
    regionName: 'Тульская область',
  },
  {
    regionCode: '72',
    regionName: 'Тюменская область',
  },
  {
    regionCode: '18',
    regionName: 'Удмуртская Республика',
  },
  {
    regionCode: '73',
    regionName: 'Ульяновская область',
  },
  {
    regionCode: '27',
    regionName: 'Хабаровский край',
  },
  {
    regionCode: '86',
    regionName: 'Ханты-Мансийский А.О. - Югра',
  },
  {
    regionCode: '74',
    regionName: 'Челябинская область',
  },
  {
    regionCode: '20',
    regionName: 'Чеченская Республика',
  },
  {
    regionCode: '21',
    regionName: 'Чувашская Республика',
  },
  {
    regionCode: '87',
    regionName: 'Чукотский А.О.',
  },
  {
    regionCode: '89',
    regionName: 'Ямало-Ненецкий А.О.',
  },
  {
    regionCode: '76',
    regionName: 'Ярославская область',
  },
];

export const UPLOAD_DOCUMENT_MOCK = {
  name: 'Устав от 15.10.2019 №123',
  fileName: 'устав_новая_редакция.pdf',
  fileUrl: '#',
  esFileName: 'устав_новая_редакция.pdf.sig',
  esFileUrl: '#',
};

export const documents = [
  {
    value: '01',
    text: 'Паспорт гражданина РФ',
  },
];
